import React from "react";

interface StarIconProps {
  height?: string;
  width?: string;
  color?: string;
  watch?: boolean;
}

const StarIcon = (props: StarIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.height ? props.height : "28px"}
      height={props.height ? props.height : "22px"}
      viewBox="0 0 24 24">
      <g
        fill={props.watch ? props.color : "#fff"}
        stroke={props.color ? props.color : props.watch ? props.color : "#ccc3ae"}>
        <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
      </g>
    </svg>
  );
};

export default StarIcon;
